import { create } from "zustand";

export const useFileStore = create((set) => ({
  uploadedFile: null,

  setUploadedFile: (fileData) => set({ uploadedFile: fileData }),
}));
